module.exports = __webpack_public_path__ + "static/media/aires_thumb.8126d751.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/aires_thumb.jpg
// module id = 167
// module chunks = 0